export default __webpack_public_path__ + "static/media/userdocs.12feb619.svg";